//dependies import ==>
import React, { useContext, useState, useEffect } from "react";
import AvatarGroup from "@mui/material/AvatarGroup";
import Avatar from "@mui/material/Avatar";
import HomeIcon from "@material-ui/icons/Home";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import "./clinic-wrapper.scss";
import useWindowSize from "../../../Hooks/useWindowSize";
//<==
//assests and scss import ==>
import AvatarIcon from "../../../assets/Avatar.svg";
import AvatarBlue from "../../../assets/AvatarBlue.svg";
import guideIcon from "../../../assets/guide_icon.png";
import abhaToken from "../../../assets/ABHA_Queue.svg";
//<==
//project file import ==>
import SelectClinic from "./SelectClinic";
import DoctorContext from "./DoctorContext";
import SelectDoctorDesktopView from "../CommonComponents/SelectDoctorModal/SelectDoctorDesktopView";
import SelectDoctorMobileView from "../CommonComponents/SelectDoctorModal/SelectDoctorMobileView";
import afterLoginApiAxios from "../../../Util/API Calls/afterLogin";
import Loader from "../../UI Component/Loader/Loader";
import sessionExpiredError from "../../Errors/sessionExpiredError";
import { removeDashboardFilterFromLocalStorage } from "../../DashboardAppointmentsView/Helper";
import {
  removeTransactionFilterFromLocalStorage,
  getTransactionFilterFromLocalStorage,
} from "../../MyTransactionsView/helper";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";
import { USER_ROLE } from "../../../Util/constants";
import { C2CConsole } from "../../../Util/Helper/C2CConsole";
import AbhaTokenViewContainer from "../../AbhaTokenViewContainer";
import { c2cGetApiHandler } from "../../../Util/c2cApiHandler";
import { DEV, QA } from "../../common/config";
import { setDynamicCookieForUser } from "../../../Util/API Calls/cookieHelper";
import { useCookies } from "react-cookie";
//<==

const useStyles = makeStyles(() =>
  createStyles({
    avatarIconMargin: {
      marginLeft: "0.5rem !important",
    },
    remainingAvatarMargin: {
      left: "-10px",
    },
    remainingAvatarequal: {
      left: "-10px",
    },
    remainingAvatarMoreThan2: {
      left: "-20px",
    },
    "@media (min-width: 992px)": {
      avatarIcon: {
        backgroundColor: "black",
        width: "40px !important",
        height: "40px !important",
      },
      avatarIconMargin: {
        marginLeft: "0px !important",
      },
      remainingAvatarMargin: {
        left: "-10px",
      },
      remainingAvatarequal: {
        left: "-10px",
      },
      remainingAvatarMoreThan2: {
        left: "-20px",
      },
    },
    "@media (min-width: 768px)": {
      avatarIcon: {
        backgroundColor: "black",
        width: "35px !important",
        height: "35px !important",
      },
      avatarIconMargin: {
        marginLeft: "0px !important",
      },
      remainingAvatarMargin: {
        left: "0px",
      },
      remainingAvatarequal: {
        left: "-10px",
      },
      remainingAvatarMoreThan2: {
        left: "-20px",
      },
    },
    "@media (min-width: 1200px)": {
      avatarIcon: {
        backgroundColor: "black",
        width: "40px !important",
        height: "40px !important",
      },
      avatarIconMargin: {
        marginLeft: "0px !important",
      },
      remainingAvatarMargin: {
        left: "0px",
      },
      remainingAvatarequal: {
        left: "-10px",
      },
      remainingAvatarMoreThan2: {
        left: "-20px",
      },
    },
    "@media (max-width: 600px)": {
      avatarIcon: {
        backgroundColor: "black",
        width: "30px !important",
        height: "30px !important",
      },
      avatarIconMargin: {
        marginLeft: "-10px !important",
      },
      remainingAvatarMargin: {
        left: "-10px",
      },
      remainingAvatarequal: {
        left: "-10px",
      },
      remainingAvatarMoreThan2: {
        left: "-20px",
      },
    },
    "@media (max-width: 767px)": {
      avatarIcon: {
        backgroundColor: "black",
        width: "40px !important",
        height: "40px !important",
      },
      avatarIconMargin: {
        marginLeft: "0px !important",
      },
      remainingAvatarMargin: {
        left: "-10px",
      },
      remainingAvatarequal: {
        left: "-10px",
      },
      remainingAvatarMoreThan2: {
        left: "-14px",
      },
    },
  })
);

const ClinicWrapper = (props) => {
  //const ==>
  const classes = useStyles();
  const {
    isPageHeading,
    headerText,
    joyrideToggle,
    homeClick,
    hideAVatar,
    hideAbhaQueue,
    hideGroupAvatar,
    setClinicMenu,
    displayAdditionalHeaderUI,
  } = props;

  var firstNameHeaderText = headerText?.split(" ").slice(0, 2).join(".");
  var lastNameHeaderText = headerText?.split(" ").slice(2, 4).join(" ");

  const doctor_context = useContext(DoctorContext);
  const [clinicList, setClinicList] = useState([]);
  const [selectedClinic, setSelectedClinic] = useState(null);
  const [doctorlist, setDoctorlist] = useState([]);
  const [doctorselectModal, setDoctorSelectModal] = useState(false);
  const [showMobileView, setShowMobileView] = useState(false);
  const size = useWindowSize();
  const maxAvatars = size.width < 786 ? 1 : 2;
  const [loading, setLoading] = useState(false);
  const [isOpen, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [showAbhaTokenContainer, setShowAbhaTokenContainer] = useState(false);
  const [tokenCount, setTokenCount] = useState(0);

  let doctorClinicAssociation = localStorage.getItem(
    LOCALSTORAGEKEY.DOCTOR_CLINIC_ASSOCIATION
  );
  let staffClinicAssociation = localStorage.getItem(
    LOCALSTORAGEKEY.STAFF_CLINIC_ASSOCIATION
  );
  let userType = localStorage.getItem(LOCALSTORAGEKEY.USER_TYPE);
  let doctorRole = localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE);
  let clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
  let userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  let doctor_role_name = localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE_NAME);
  let staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);
  const abhaTokenCount = localStorage.getItem(LOCALSTORAGEKEY.ABHA_TOKEN_COUNT);

  const clinicOptions = [
    {
      clinic_name: "My Clinic",
      clinic_locality: null,
      doctor_id: userId,
    },
  ];
  const [cookies, setCookie] = useCookies(["cookie-name"]);
  //<==

  useEffect(() => {
    if (
      (userType === "doctor" && doctorClinicAssociation == "true") ||
      (userType === "staff" && staffClinicAssociation == "true")
    ) {
      getClinicList();
    } else {
      setClinicList([
        {
          clinic_name: "My Virtual Clinic",
          clinic_locality: null,
          doctor_id: userId,
        },
      ]);
      let obj = {
        clinic_name: "My Clinic",
        clinic_locality: null,
        doctor_id: userId,
      };
      setSelectedClinic(obj);
      handleClinicDetailsContext(obj);
    }
  }, []);

  useEffect(() => {
    const filteredDoctors = [];

    if (doctor_context?.selectedDoctor?.length > 0) {
      for (const doctor of doctor_context.selectedDoctor) {
        if (
          localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE) !==
            USER_ROLE.RESOURCE_ADMIN ||
          doctor.is_resource === "True"
        ) {
          filteredDoctors.push(doctor);
        }
      }

      setDoctorlist(
        filteredDoctors.filter((doctor) => doctor.selected === true)
      );
    }
  }, [doctor_context.selectedDoctor]);

  useEffect(() => {
    getABHATokenCount();
  }, [clinicId]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      const newValue = localStorage.getItem(LOCALSTORAGEKEY.ABHA_TOKEN_COUNT);
      if (newValue && newValue !== abhaTokenCount) {
        setTokenCount(newValue);
      }
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, [abhaTokenCount]);

  const getClinicList = async () => {
    let params = {};
    if (userType === "staff") {
      params["staff_id"] = staffId;
    } else {
      if (userId) {
        params["doctor_id"] = userId;
      }
    }
    try {
      // const res = await afterLoginApiAxios.get("clinic/get-all-clinic-list", {
      const res = await afterLoginApiAxios.get(
        `${
          userType === "staff"
            ? "clinic/get-all-clinic-list-staff"
            : "clinic/get-all-clinic-list"
        }`,
        {
          headers: {
            Authorization: localStorage.getItem("id_token"),
          },
          params: params,
        }
      );
      if (res?.data?.response === 200) {
        let clinicList = res?.data?.clinc_list
          ? res?.data?.clinc_list
          : res?.data?.clinic_list;
        let personal = [
          {
            clinic_name: res?.data?.personal_clinic_details?.doctor_clinic_name,
            clinic_locality:
              res?.data?.personal_clinic_details?.doctor_clinic_address,
            doctor_id: "",
          },
        ];
        let list = [];

        if (
          doctor_role_name === USER_ROLE.RESOURCE_ADMIN ||
          doctor_role_name === USER_ROLE.RESOURCE_CONSULTANT
        ) {
          localStorage.setItem(LOCALSTORAGEKEY.DOCTOR_ROLE, doctor_role_name);
          setDynamicCookieForUser(
            LOCALSTORAGEKEY.DOCTOR_ROLE,
            doctor_role_name,
            setCookie
          );
          list = [
            {
              label: "OTHER CLINICS",
              options: clinicList,
            },
          ];
        } else {
          if (userType === "staff") {
            if (
              localStorage.getItem("staff_doctor_association") &&
              localStorage.getItem("staff_doctor_association") === "true"
            ) {
              list = [
                {
                  label: "C2C VIRTUAL CLINIC",
                  options: personal[0].clinic_name ? personal : clinicOptions,
                },
                {
                  label: "OTHER CLINICS",
                  options: clinicList,
                },
              ];
            } else {
              list = [
                {
                  label: "OTHER CLINICS",
                  options: clinicList,
                },
              ];
            }
          } else {
            list = [
              {
                label: "C2C VIRTUAL CLINIC",
                options: personal[0].clinic_name ? personal : clinicOptions,
              },
              {
                label: "OTHER CLINICS",
                options: clinicList,
              },
            ];
          }
        }

        setClinicList(list);

        if (!clinicId && list[0]?.options[0]?.clinic_id) {
          setDynamicCookieForUser(
            LOCALSTORAGEKEY.CLINIC_ID,
            list[0]?.options[0]?.clinic_id,
            setCookie
          );
          localStorage.setItem(
            LOCALSTORAGEKEY.CLINIC_ID,
            list[0]?.options[0]?.clinic_id
          );
          localStorage.setItem("clinicName", list[0]?.options[0]?.clinic_name);
        }
        //need to read localstorage directly here, not from the defined constant. It is getting set just abode the comment.
        if (localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID) !== null) {
          let currentSelectedClinic =
            clinicList?.length &&
            clinicList.filter(
              (clinic) =>
                clinic?.clinic_id ==
                localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID)
            );
          if (currentSelectedClinic && currentSelectedClinic.length > 0) {
            setSelectedClinic(currentSelectedClinic[0]);
            handleClinicDetailsContext(currentSelectedClinic[0]);
            localStorage.setItem(
              LOCALSTORAGEKEY.IS_CLINIC_AND_LAB,
              currentSelectedClinic[0]?.is_clinic_and_lab?.toLowerCase() ===
                "true"
            );
            localStorage.setItem(
              LOCALSTORAGEKEY.IS_LAB,
              currentSelectedClinic[0]?.is_lab?.toLowerCase() === "true"
            );
            localStorage.setItem(
              LOCALSTORAGEKEY.ENABLE_LEADS_DASHBOARD,
              currentSelectedClinic[0]?.enable_leads_dashboard?.toLowerCase() ===
                "true"
            );
            doctor_context.setEnableLeadsDashboard(
              currentSelectedClinic[0]?.enable_leads_dashboard?.toLowerCase() ===
                "true"
            );
            localStorage.setItem(
              LOCALSTORAGEKEY.ENABLE_CALL_APPOINTMENT_PATIENTS,
              currentSelectedClinic[0]?.enable_call_appointment_patients?.toLowerCase() ===
                "true"
            );
            localStorage.setItem(
              LOCALSTORAGEKEY.ENABLE_CALL_LEADS_PATINETS,
              currentSelectedClinic[0]?.enable_call_leads_patients?.toLowerCase() ===
                "true"
            );
          } else {
            if (personal[0].clinic_name) {
              setSelectedClinic(personal[0]);
              handleClinicDetailsContext(personal[0]);
            } else {
              let obj = {
                clinic_name: "My Clinic",
                clinic_locality: null,
                doctor_id: userId,
              };
              setSelectedClinic(obj);
              handleClinicDetailsContext(obj);
            }
          }
        } else {
          localStorage.setItem(LOCALSTORAGEKEY.IS_CLINIC_AND_LAB, false);
          localStorage.setItem(LOCALSTORAGEKEY.IS_LAB, false);
          localStorage.setItem(LOCALSTORAGEKEY.ENABLE_LEADS_DASHBOARD, false);
          doctor_context.setEnableLeadsDashboard(false);
          localStorage.setItem(
            LOCALSTORAGEKEY.ENABLE_CALL_APPOINTMENT_PATIENTS,
            false
          );
          localStorage.setItem(
            LOCALSTORAGEKEY.ENABLE_CALL_LEADS_PATINETS,
            false
          );
          if (personal[0].clinic_name) {
            setSelectedClinic(personal[0]);
            handleClinicDetailsContext(personal[0]);
          } else {
            let obj = {
              clinic_name: "My Clinic",
              clinic_locality: null,
              doctor_id: userId,
            };
            setSelectedClinic(obj);
            handleClinicDetailsContext(obj);
          }
        }
      } else {
        localStorage.setItem(LOCALSTORAGEKEY.IS_CLINIC_AND_LAB, false);
        localStorage.setItem(LOCALSTORAGEKEY.IS_LAB, false);
        localStorage.setItem(LOCALSTORAGEKEY.ENABLE_LEADS_DASHBOARD, false);
        doctor_context.setEnableLeadsDashboard(false);
        localStorage.setItem(
          LOCALSTORAGEKEY.ENABLE_CALL_APPOINTMENT_PATIENTS,
          false
        );
        localStorage.setItem(LOCALSTORAGEKEY.ENABLE_CALL_LEADS_PATINETS, false);
        let obj = {
          clinic_name: "My Clinic",
          clinic_locality: null,
          doctor_id: userId,
        };
        setSelectedClinic(obj);
        handleClinicDetailsContext(obj);
        setClinicList([
          {
            label: "C2C VIRTUAL CLINIC",
            options: clinicOptions,
          },
        ]);
      }
    } catch (error) {
      setClinicList([
        {
          label: "C2C VIRTUAL CLINIC",
          options: clinicOptions,
        },
      ]);
      if (error?.response?.status === 403) {
        sessionExpiredError(() => {
          localStorage.clear();
          this.props.history.push("/doctor/login");
        });
      }
      C2CConsole.log(error);
    }
  };

  const handleModal = () => {
    if (size && size?.width < 786) {
      setShowMobileView(true);
    } else {
      setDoctorSelectModal(true);
    }
  };
  function renderRemaining() {
    const remaining = doctorlist?.length - maxAvatars;
    let dd = "+" + remaining?.toString();
    if (remaining < 1) return null;
    return (
      <Avatar
        sx={{
          bgcolor: "#17BAE0 !important",
          border: "2px solid white",
          boxSizing: "content-box",
          cursor: "pointer",
          textTransform: "capitalize",
        }}
        style={{ position: "relative", left: `${-16 * maxAvatars + 1}px` }}
        src="/static/images/avatar/1.jpg"
        alt={dd}
        onClick={handleModal}
        className={`${classes.avatarIconMargin} ${classes.avatarIcon}`}
      >
        <p style={{ fontSize: "16px", margin: "0px", color: "white" }}>{dd}</p>
      </Avatar>
    );
  }

  const groupAvatar = () => {
    return (
      <>
        {doctorlist?.slice(0, maxAvatars)?.map((doctor, i) => (
          <Avatar
            key={i}
            alt={doctor?.doctor_first_name}
            sx={{
              bgcolor: "#17BAE0 !important",
              border: "2px solid white",
              boxSizing: "content-box",
              cursor: "pointer",
              textTransform: "capitalize",
            }}
            src={
              doctor?.doctor_profile_picture_url?.length > 0 &&
              doctor.doctor_profile_picture_url[0]
            }
            style={{ position: "relative", left: `${-16 * i}px` }}
            onClick={handleModal}
            className={`${classes.avatarIconMargin} ${classes.avatarIcon}`}
          />
        ))}
        {renderRemaining()}
      </>
    );
  };

  const handleOnChange = (clinic) => {
    localStorage.setItem("clinicName", clinic.clinic_name);
    localStorage.setItem(
      LOCALSTORAGEKEY.IS_CLINIC_AND_LAB,
      clinic?.is_clinic_and_lab?.toLowerCase() === "true"
    );
    localStorage.setItem(
      LOCALSTORAGEKEY.IS_LAB,
      clinic?.is_lab?.toLowerCase() === "true"
    );
    localStorage.setItem(
      LOCALSTORAGEKEY.ENABLE_LEADS_DASHBOARD,
      clinic?.enable_leads_dashboard?.toLowerCase() === "true"
    );
    doctor_context.setEnableLeadsDashboard(
      clinic?.enable_leads_dashboard?.toLowerCase() === "true"
    );
    localStorage.setItem(
      LOCALSTORAGEKEY.ENABLE_CALL_APPOINTMENT_PATIENTS,
      clinic?.enable_call_appointment_patients?.toLowerCase() === "true"
    );
    localStorage.setItem(
      LOCALSTORAGEKEY.ENABLE_CALL_LEADS_PATINETS,
      clinic?.enable_call_leads_patients?.toLowerCase() === "true"
    );
    localStorage.setItem(
      LOCALSTORAGEKEY.ENABLE_ALLOW_SHARE_RX,
      clinic?.allow_share_rx
    );

    if (selectedClinic !== clinic) {
      localStorage.removeItem("dashboardDoctorName");
      localStorage.removeItem("dashboardStartDate");
      localStorage.removeItem("dashboardEndDate");
      localStorage.removeItem("appointmentConsultationFilter");
      localStorage.removeItem("appointmentStatusFilter");
      localStorage.removeItem("appointmentDoctorName");
      localStorage.removeItem("appointmentStartDate");
      localStorage.removeItem("appointment_status_filter");
      localStorage.removeItem("appointmentPrescriptionFilter");
      localStorage.removeItem("appointmentEndDate");
      localStorage.removeItem("appointmentCheckInStartDate");
      localStorage.removeItem("appointmentCheckInEndDate");
      localStorage.removeItem("appointmentSortingFilter");
      localStorage.removeItem("transactionDoctorNameFilter");
      const transactionFilters = getTransactionFilterFromLocalStorage();
      if (!transactionFilters) {
        localStorage.removeItem("transactionDefaultDate");
      }
      removeDashboardFilterFromLocalStorage();
      removeTransactionFilterFromLocalStorage();
    }
    setSelectedClinic(clinic);
    handleClinicDetailsContext(clinic);
    doctor_context.setClinicId(clinic?.clinic_id ? clinic.clinic_id : "");
    doctor_context.setDoctorRole(clinic ? clinic?.doctor_role_name : "");
    // if (clinic?.clinic_name?.toLowerCase() !== 'my clinic')
    if (clinic?.clinic_id && clinic?.clinic_id !== "") {
      setDynamicCookieForUser(
        LOCALSTORAGEKEY.CLINIC_ID,
        clinic?.clinic_id ? clinic.clinic_id : "",
        setCookie
      );
      localStorage.setItem(
        LOCALSTORAGEKEY.CLINIC_ID,
        clinic?.clinic_id ? clinic.clinic_id : ""
      );
      if (userType == "staff") {
        localStorage.removeItem(LOCALSTORAGEKEY.DOCTOR_ROLE);
      } else {
        localStorage.setItem(
          LOCALSTORAGEKEY.DOCTOR_ROLE,
          clinic ? clinic?.doctor_role_name : ""
        );
        setDynamicCookieForUser(
          LOCALSTORAGEKEY.DOCTOR_ROLE,
          clinic ? clinic?.doctor_role_name : "",
          setCookie
        );
      }
      if (
        clinic?.doctor_role_name != "consultant" ||
        clinic?.doctor_role_name != "resource_consultant"
      ) {
        getDoctorList(clinic?.clinic_id);
        doctor_context.setDoctorList([]);
      } else {
        doctor_context.setDoctorList([
          {
            doctor_id: userId,
            id: userId,
          },
        ]);
      }
    } else if (
      //else if codition to get doctor list for my clinic for staff
      // clinic?.clinic_name?.toLowerCase() == 'my clinic' &&
      userType == "staff"
    ) {
      localStorage.removeItem(LOCALSTORAGEKEY.CLINIC_ID);
      localStorage.removeItem(LOCALSTORAGEKEY.DOCTOR_ROLE);
      getDoctorListForStaffMyClinic();
    } else {
      localStorage.removeItem(LOCALSTORAGEKEY.CLINIC_ID);
      localStorage.removeItem(LOCALSTORAGEKEY.DOCTOR_ROLE);
      props.handleVirtualClinic && props.handleVirtualClinic();
    }
  };

  const getDoctorList = (id) => {
    setLoading(true);
    afterLoginApiAxios
      .get("clinic/get-clinic-doctors", {
        headers: {
          Authorization: localStorage.getItem("id_token"),
        },
        params: {
          clinic_id: id,
        },
      })
      .then((res) => {
        if (res?.data?.statusCode === 200) {
          setLoading(false);
          res?.data?.doctor_list?.length > 0 &&
            res.data.doctor_list.map(
              (doctor_list) => (doctor_list.seleted = false)
            );
          let result = [];
          let doctorSelected = JSON.parse(
            localStorage.getItem(LOCALSTORAGEKEY.PREVIOUS_SELECTED_DOCTORS)
          );

          if (
            doctorSelected?.length > 0 &&
            doctorSelected !== null &&
            (id !== null || id !== undefined)
          ) {
            var foundIndex = doctorSelected?.findIndex(
              (selectedClinicId) => selectedClinicId?.clinic_id === id
            );

            if (foundIndex > -1) {
              result = res?.data?.doctor_list?.map((doctor) => {
                let selectedDoctor = doctorSelected[foundIndex]?.doctors?.some(
                  (selectedDoctor) =>
                    doctor?.doctor_id === selectedDoctor?.doctor_id
                );
                if (selectedDoctor) {
                  return {
                    ...doctor,
                    selected: true,
                    selected_doctor: false,
                    id: doctor?.doctor_id,
                    label: doctor?.doctor_name,
                    value: doctor?.doctor_name,
                    name: doctor?.doctor_name,
                    initials: doctor?.doctor_name?.charAt(0),
                  };
                } else {
                  return {
                    ...doctor,
                  };
                }
              });
              doctor_context.setDoctorList(result);
            } else {
              let selectedDoctorArr = [];
              doctorSelected = doctorSelected || [];
              selectedDoctorArr = res?.data?.doctor_list?.map((doctor) => {
                return {
                  ...doctor,
                  selected: true,
                  selected_doctor: false,
                  id: doctor?.doctor_id,
                  label: doctor?.doctor_name,
                  value: doctor?.doctor_name,
                  name: doctor?.doctor_name,
                  initials: doctor?.doctor_name?.charAt(0),
                };
              });
              doctorSelected.push({
                clinic_id: id,
                doctors: selectedDoctorArr,
              });
              // console.log(" ----> a2", doctorSelected);
              localStorage.setItem(
                LOCALSTORAGEKEY.PREVIOUS_SELECTED_DOCTORS,
                JSON.stringify(doctorSelected)
              );
              setDynamicCookieForUser(
                LOCALSTORAGEKEY.PREVIOUS_SELECTED_DOCTORS,
                JSON.stringify(doctorSelected),
                setCookie
              );
              doctor_context.setDoctorList(selectedDoctorArr);
            }
          } else {
            let selectedDoctorArr = [];
            doctorSelected = doctorSelected || [];
            selectedDoctorArr = res?.data?.doctor_list?.map((doctor) => {
              return {
                ...doctor,
                selected: true,
                selected_doctor: false,
                id: doctor?.doctor_id,
                label: doctor?.doctor_name,
                value: doctor?.doctor_name,
                name: doctor?.doctor_name,
                initials: doctor?.doctor_name?.charAt(0),
              };
            });
            doctorSelected.push({
              clinic_id: id,
              doctors: selectedDoctorArr,
            });
            // console.log(" ----> a3", doctorSelected);
            localStorage.setItem(
              LOCALSTORAGEKEY.PREVIOUS_SELECTED_DOCTORS,
              JSON.stringify(doctorSelected)
            );
            setDynamicCookieForUser(
              LOCALSTORAGEKEY.PREVIOUS_SELECTED_DOCTORS,
              JSON.stringify(doctorSelected),
              setCookie
            );
            doctor_context.setDoctorList(selectedDoctorArr);
          }
        } else {
          setLoading(false);
          doctor_context.setDoctorList([]);
          setDoctorlist([]);
          // doctor_context.setPreviousSelectedDoctorList([]);
          // console.log(" ----> a4");
          localStorage.removeItem(LOCALSTORAGEKEY.PREVIOUS_SELECTED_DOCTORS);
        }
      })
      .catch((error) => {
        setLoading(false);
        doctor_context.setDoctorList([]);
        setDoctorlist([]);
        // doctor_context.setPreviousSelectedDoctorList([]);
        // console.log(" ----> a5");
        localStorage.removeItem(LOCALSTORAGEKEY.PREVIOUS_SELECTED_DOCTORS);
        if (error?.response?.status === 403) {
          sessionExpiredError(() => {
            localStorage.clear();
            this.props.history.push("/doctor/login");
          });
        }
        C2CConsole.log(error);
      });
  };

  const getDoctorListForStaffMyClinic = () => {
    setLoading(true);
    afterLoginApiAxios({
      method: "post",
      url: "/staff/get-complete-staff-info",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("id_token"),
      },
      data: {
        "authorizer-principal-id": {
          user_type: 4,
          staff_id: staffId,
        },
        staff_id: staffId,
        search: "False",
        dr_name: "",
        dr_phone_no: "",
      },
    })
      .then((res) => {
        if (res?.data?.statusCode === 200) {
          setLoading(false);
          res?.data?.all_related_doctors?.length > 0 &&
            res.data.all_related_doctors.map(
              (doctor_list) => (doctor_list.seleted = false)
            );
          let result = [];
          let doctorSelected = JSON.parse(
            localStorage.getItem(LOCALSTORAGEKEY.PREVIOUS_SELECTED_DOCTORS)
          );
          // console.log(" ----> a6", doctorSelected);
          if (
            doctorSelected?.length > 0 &&
            doctorSelected !== null &&
            (clinicId !== null || clinicId !== undefined)
          ) {
            var foundIndex = doctorSelected?.findIndex(
              (selectedClinicId) => selectedClinicId?.clinic_id === clinicId
            );

            if (foundIndex > -1) {
              result = res?.data?.all_related_doctors?.map((doctor) => {
                let selectedDoctor = doctorSelected[foundIndex]?.doctors?.some(
                  (selectedDoctor) =>
                    doctor?.doctor_id === selectedDoctor?.doctor_id
                );
                if (selectedDoctor) {
                  return {
                    ...doctor,
                    selected: true,
                    selected_doctor: false,
                    doctor_first_name: doctor?.dr_first_name,
                    doctor_last_name:
                      doctor?.dr_middle_name + " " + doctor?.dr_last_name,
                    doctor_profile_picture_url: doctor?.profile_picture_url
                      ? [doctor?.profile_picture_url]
                      : [],
                    id: doctor?.doctor_id,
                    label: doctor?.dr_name,
                    value: doctor?.dr_first_name,
                    name: doctor?.dr_name,
                    initials: doctor?.dr_first_name?.charAt(0),
                    doctor_phone_no: doctor?.dr_phone_no,
                    doctor_name: doctor?.dr_name,
                  };
                } else {
                  return {
                    ...doctor,
                    doctor_first_name: doctor?.dr_first_name,
                    doctor_last_name:
                      doctor?.dr_middle_name + " " + doctor?.dr_last_name,
                    doctor_profile_picture_url: doctor?.profile_picture_url
                      ? [doctor?.profile_picture_url]
                      : [],
                    id: doctor?.doctor_id,
                    label: doctor?.dr_name,
                    value: doctor?.dr_first_name,
                    name: doctor?.dr_name,
                    initials: doctor?.dr_first_name?.charAt(0),
                    doctor_phone_no: doctor?.dr_phone_no,
                    doctor_name: doctor?.dr_name,
                  };
                }
              });
              doctor_context.setDoctorList(result);
            } else {
              let selectedDoctorArr = [];
              doctorSelected = doctorSelected || [];
              selectedDoctorArr = res?.data?.all_related_doctors?.map(
                (doctor) => {
                  return {
                    ...doctor,
                    selected: true,
                    selected_doctor: false,
                    doctor_first_name: doctor?.dr_first_name,
                    doctor_last_name:
                      doctor?.dr_middle_name + " " + doctor?.dr_last_name,
                    doctor_profile_picture_url: doctor?.profile_picture_url
                      ? [doctor?.profile_picture_url]
                      : [],
                    id: doctor?.doctor_id,
                    label: doctor?.dr_name,
                    value: doctor?.dr_first_name,
                    name: doctor?.dr_name,
                    initials: doctor?.dr_first_name?.charAt(0),
                    doctor_phone_no: doctor?.dr_phone_no,
                    doctor_name: doctor?.dr_name,
                  };
                }
              );
              doctorSelected.push({
                clinic_id: clinicId,
                doctors: selectedDoctorArr,
              });
              // console.log(" ----> a7", doctorSelected);
              localStorage.setItem(
                LOCALSTORAGEKEY.PREVIOUS_SELECTED_DOCTORS,
                JSON.stringify(doctorSelected)
              );
              setDynamicCookieForUser(
                LOCALSTORAGEKEY.PREVIOUS_SELECTED_DOCTORS,
                JSON.stringify(doctorSelected),
                setCookie
              );
              doctor_context.setDoctorList(selectedDoctorArr);
            }
          } else {
            let selectedDoctorArr = [];
            doctorSelected = doctorSelected || [];
            selectedDoctorArr = res?.data?.all_related_doctors?.map(
              (doctor) => {
                return {
                  ...doctor,
                  selected: true,
                  selected_doctor: false,
                  doctor_first_name: doctor?.dr_first_name,
                  doctor_last_name:
                    doctor?.dr_middle_name + " " + doctor?.dr_last_name,
                  doctor_profile_picture_url: doctor?.profile_picture_url
                    ? [doctor?.profile_picture_url]
                    : [],
                  id: doctor?.doctor_id,
                  label: doctor?.dr_name,
                  value: doctor?.dr_first_name,
                  name: doctor?.dr_name,
                  initials: doctor?.dr_first_name?.charAt(0),
                  doctor_phone_no: doctor?.dr_phone_no,
                  doctor_name: doctor?.dr_name,
                };
              }
            );
            doctorSelected.push({
              clinic_id: clinicId,
              doctors: selectedDoctorArr,
            });
            // console.log(" ----> a8", doctorSelected);
            localStorage.setItem(
              LOCALSTORAGEKEY.PREVIOUS_SELECTED_DOCTORS,
              JSON.stringify(doctorSelected)
            );
            setDynamicCookieForUser(
              LOCALSTORAGEKEY.PREVIOUS_SELECTED_DOCTORS,
              JSON.stringify(doctorSelected),
              setCookie
            );
            doctor_context.setDoctorList(selectedDoctorArr);
          }
        } else {
          // console.log(" ----> a9");
          setLoading(false);
          doctor_context.setDoctorList([]);
          setDoctorlist([]);
          localStorage.removeItem(LOCALSTORAGEKEY.PREVIOUS_SELECTED_DOCTORS);
        }
      })
      .catch((error) => {
        setLoading(false);
        doctor_context.setDoctorList([]);
        setDoctorlist([]);
        // console.log(" ----> a10");
        localStorage.removeItem(LOCALSTORAGEKEY.PREVIOUS_SELECTED_DOCTORS);
        if (error?.response?.status === 403) {
          sessionExpiredError(() => {
            localStorage.clear();
            this.props.history.push("/doctor/login");
          });
        }
        C2CConsole.log(error);
      });
  };

  const handleClinicDetailsContext = (value) => {
    localStorage.setItem(
      LOCALSTORAGEKEY.SELECTED_CLINIC_DETAILS,
      JSON.stringify(value)
    );
  };

  const getABHATokenCount = () => {
    const abhaTokenCountResponse = c2cGetApiHandler(
      `/abha/v1/${clinicId}/get-tokens-count`
    );
    abhaTokenCountResponse.then(([res, err]) => {
      if (!err && res?.data?.statusCode === 200) {
        setTokenCount(res?.data?.count);
      }
    });
  };

  const displayUserDetails = () => {
    let display = null;
    if (
      staffClinicAssociation === "true" ||
      doctorClinicAssociation === "true"
    ) {
      display = (
        <div>
          <p className="welcome-text d-flex flex-column">Welcome Back,</p>
          <div className="d-flex" id="clinic">
            <p className="header-text">
              {headerText.includes("Dr")
                ? firstNameHeaderText + " " + lastNameHeaderText
                : headerText}
            </p>
            {(doctorRole || userType === "staff") && (
              <div className="ml-2 tag-container">
                <p className="tag-text">
                  <p className="tag-text">
                    {userType === "staff"
                      ? "Staff"
                      : doctorRole === "resource_consultant"
                      ? "Resource Consultant"
                      : doctorRole === "resource_administrator"
                      ? "Resource Administrator"
                      : doctorRole}
                  </p>
                </p>
              </div>
            )}
          </div>
        </div>
      );
    }
    return display;
  };

  // Actions ==>

  const handleAbhaToken = () => {
    setShowAbhaTokenContainer(true);
  };

  const handleCloseAbhaContainer = () => {
    setShowAbhaTokenContainer(false);
  };

  // <===

  return (
    <>
      <div className="clinic-dropdown-container">
        <div style={{ display: "flex", alignItems: "center" }}>
          <div
            className="clinic-wrapper-container d-flex border-right select-wrapper"
            style={{ height: "70px", zIndex: "11" }}
          >
            <SelectClinic
              doctorRole={doctorRole}
              options={clinicList}
              defaultValue={selectedClinic}
              setSelectedClinic={setSelectedClinic}
              noOptionsMessage={"No Clinic Found"}
              handleOnChange={handleOnChange}
              onMenuOpen={(status) => {
                setClinicMenu && setClinicMenu(status);
              }}
            />
          </div>
          <div className="mobile_heading">
            <div className="clinic-wrapper-container d-flex w-100 justify-content-between ml-2 align-self-center">
              {!isPageHeading ? (
                displayUserDetails()
              ) : (
                <p className="page-heading d-none d-sm-none d-lg-flex d-flex">
                  {headerText ? headerText : "Page Heading"}{" "}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex w-100 justify-content-end align-items-center">
        {loading ? (
          <Loader />
        ) : (
          <div style={{ display: "flex", flexDirection: "end" }}>
            {displayAdditionalHeaderUI && displayAdditionalHeaderUI()}
            {(process.env.REACT_APP_ENV === DEV ||
              process.env.REACT_APP_ENV === QA ||
              window.location.hostname === "localhost") && (
              <>
                {clinicId &&
                  selectedClinic?.abdm_hfr_id &&
                  doctorRole !== USER_ROLE.DOCTOR_CONSULTANT &&
                  doctorRole !== USER_ROLE.RESOURCE_CONSULTANT &&
                  !hideAbhaQueue && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        position: "relative",
                        cursor: "pointer",
                        marginRight: "10px",
                      }}
                      data-tooltip="ABHA Token"
                      data-tooltip-conf="bottom"
                    >
                      <div
                        style={{
                          position: "absolute",
                          background: "#F969A4",
                          borderRadius: "50%",
                          height: "16px",
                          width: "16px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          top: "8px",
                          left: "8px",
                          font: "normal normal normal 10px/20px Rubik",
                          color: "#FFFFFF",
                        }}
                        onClick={handleAbhaToken}
                      >
                        {tokenCount}
                      </div>
                      <img
                        src={abhaToken}
                        alt=""
                        style={{ cursor: "pointer" }}
                        onClick={handleAbhaToken}
                      />
                    </div>
                  )}
              </>
            )}

            {!isPageHeading && (
              <div className="d-sm-none d-lg-flex d-none mr-3 ">
                <div className={"d-flex align-items-center"}>
                  <div
                    className={"mx-3"}
                    style={{ width: "20px", cursor: "pointer" }}
                  >
                    <HomeIcon
                      className="doctor-info-home-icon"
                      onClick={homeClick}
                    />
                  </div>
                </div>
                <div
                  className={"d-none align-items-center"} //d-flex
                  style={{
                    borderRight:
                      (doctorRole !== "consultant" && clinicId !== null) ||
                      userType === "staff"
                        ? "1px solid #D6DAE5"
                        : "none",
                  }}
                >
                  <div
                    className={"mx-3"}
                    style={{ width: "24px", cursor: "pointer" }}
                  >
                    <img src={guideIcon} alt="guid" onClick={joyrideToggle} />
                  </div>
                </div>
              </div>
            )}
            {((selectedClinic?.clinic_name?.toLowerCase() !== "my clinic" &&
              (selectedClinic?.doctor_role_name?.toLowerCase() ==
                "administrator" ||
                userType === "staff" ||
                selectedClinic?.doctor_role_name?.toLowerCase() ==
                  "resource_administrator") &&
              !hideAVatar) ||
              (!clinicId && userType === "staff")) &&
              !hideGroupAvatar &&
              groupAvatar()}
            {((selectedClinic?.clinic_name?.toLowerCase() !== "my clinic" &&
              (selectedClinic?.doctor_role_name?.toLowerCase() ==
                "administrator" ||
                selectedClinic?.doctor_role_name?.toLowerCase() ==
                  "resource_administrator" ||
                userType === "staff") &&
              !hideAVatar) ||
              (!clinicId && userType === "staff")) &&
              !hideGroupAvatar && (
                <AvatarGroup>
                  <Avatar
                    className={`${classes.avatarIconMargin}
                     ${classes.avatarIcon} ${
                      doctorlist?.length === 1
                        ? classes.remainingAvatarMargin
                        : doctorlist?.length === 2
                        ? classes.remainingAvatarequal
                        : classes.remainingAvatarMoreThan2
                    }`}
                    src={doctorlist?.length > 1 ? AvatarIcon : AvatarBlue}
                    sx={{
                      bgcolor: "white !important",
                      boxSizing: "content-box",
                      cursor: "pointer",
                      textTransform: "capitalize",
                    }}
                    onClick={handleModal}
                  />
                </AvatarGroup>
              )}
          </div>
        )}
      </div>

      {doctorselectModal ? (
        <SelectDoctorDesktopView
          show={doctorselectModal}
          onHide={() => {
            setDoctorSelectModal(false);
          }}
        />
      ) : null}

      {showMobileView ? (
        <SelectDoctorMobileView
          show={showMobileView}
          onHide={() => setShowMobileView(false)}
        />
      ) : null}

      {showAbhaTokenContainer && (
        <AbhaTokenViewContainer
          showAbhaTokenContainer={showAbhaTokenContainer}
          selectedClinic={selectedClinic}
          handleCloseAbhaContainer={handleCloseAbhaContainer}
        />
      )}
    </>
  );
};

export default ClinicWrapper;
